import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { DirektvermarktungContractOverviewResponse } from "../Direktvermarktung.types";
import { direktvermarktungContractQueries } from "./useDirektvermarktungContract";
import { direktvermarktungContractsQueries } from "./useDirektvermarktungContracts";

interface UseDirektvermarktungContractExtensionMutationParams {
  contractId: DirektvermarktungContractOverviewResponse["id"];
  newEndDate: string;
}

export function useDirektvermarktungContractExtensionMutation() {
  const queryClient = useQueryClient();

  function extendContract({
    contractId,
    newEndDate
  }: UseDirektvermarktungContractExtensionMutationParams) {
    return apiWithoutCamelization.post(
      urls.apiWithoutCamelization.direktvermarktungContractExtension(
        contractId
      ),
      { last_date: newEndDate }
    );
  }

  return useMutation({
    mutationFn: extendContract,
    onSuccess: (_, contract) => {
      queryClient.invalidateQueries({
        queryKey: direktvermarktungContractsQueries.all().queryKey
      });
      queryClient.invalidateQueries({
        queryKey: direktvermarktungContractQueries.detail(contract.contractId)
          .queryKey
      });
    }
  });
}
